import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["disabled", "data-disabled", "data-invalid", "data-focus", "data-hover", "required", "value", "name"]
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    class: "size-5 stroke-zinc-500 group-has-[[data-disabled]]:stroke-zinc-600 sm:size-4 dark:stroke-zinc-400 forced-colors:stroke-[CanvasText]",
    viewBox: "0 0 16 16",
    "aria-hidden": "true",
    fill: "none"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M5.75 10.75L8 13L10.25 10.75",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M10.25 5.25L8 3L5.75 5.25",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    })
  ])
], -1)

import { 
		clsx
	} from 'clsx'

	import {
		inject,
		nextTick,
		ref
	} from 'vue'

	
	const __default__ = { name: 'VSelect' }// name the component

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
		modelValue: {
			type: [String, Number, Array],
			default: null
		},
		className: {
			type: String,
			default: ''
		},
		disabled: {
			type: Boolean,
			default: false
		},
		invalid: {
			type: Boolean,
			default: false
		},
		name: {
			type: String,
			default: ''
		},
		required: {
			type: Boolean,
			default: false
		}
	},
  emits: [
		'update:modelValue'
	],
  setup(__props, { emit: __emit }) {

	const props = __props

	const emit = __emit

	const fieldDisabled: boolean = inject('fieldDisabled', null) || inject('fieldsetDisabled', null) || props.disabled
	const focused = ref(false)
	const hovered = ref(false)

	// update modeled value
	const onChange = async ({ target }: any) => {
		emit('update:modelValue', target.value)
		await nextTick()
		return
	}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", {
    "data-slot": "control",
    class: _normalizeClass(_unref(clsx)([
			__props.className,
			// Basic layout
			'group relative block w-full',
			// Background color + shadow applied to inset pseudo element, so shadow blends with border in light mode
			'before:absolute before:inset-px before:rounded-[calc(theme(borderRadius.lg)-1px)] before:bg-white before:shadow',
			// Background color is moved to control and shadow is removed in dark mode so hide `before` pseudo
			'dark:before:hidden',
			// Focus ring
			'after:pointer-events-none after:absolute after:inset-0 after:rounded-lg after:ring-inset after:ring-transparent after:has-[[data-focus]]:ring-2 after:has-[[data-focus]]:ring-blue-500',
			// Disabled state
			'has-[[data-disabled]]:opacity-50 before:has-[[data-disabled]]:bg-zinc-950/5 before:has-[[data-disabled]]:shadow-none',
		]))
  }, [
    _createElementVNode("select", {
      disabled: _unref(fieldDisabled),
      "data-disabled": _unref(fieldDisabled) ? true : null,
      "data-invalid": __props.invalid ? true : null,
      "data-focus": focused.value ? true : null,
      "data-hover": hovered.value ? true : null,
      required: __props.required,
      value: __props.modelValue,
      name: __props.name ?? null,
      class: _normalizeClass(_unref(clsx)([
				__props.className,
				'bg-none',
				// Basic layout
				'relative block w-full appearance-none rounded-lg py-[calc(theme(spacing[2.5])-1px)] sm:py-[calc(theme(spacing[1.5])-1px)]',
				// Options (multi-select)
				'[&_optgroup]:font-semibold',
				// Typography
				'text-base/6 placeholder:text-zinc-500 sm:text-sm/6',
				!__props.modelValue ? 'text-zinc-500' : 'text-zinc-950 dark:text-white dark:*:text-white',
				// Border
				'border border-zinc-950/10 data-[hover]:border-zinc-950/20 dark:border-white/10 dark:data-[hover]:border-white/20',
				// Background color
				'bg-transparent dark:bg-white/5 dark:*:bg-zinc-800',
				// Hide default focus styles
				'focus:outline-none',
				// Invalid state
				'data-[invalid]:border-red-500 data-[invalid]:data-[hover]:border-red-500 data-[invalid]:dark:border-red-600 data-[invalid]:data-[hover]:dark:border-red-600',
				// Disabled state
				'data-[disabled]:border-zinc-950/20 data-[disabled]:opacity-100 dark:data-[hover]:data-[disabled]:border-white/15 data-[disabled]:dark:border-white/15 data-[disabled]:dark:bg-white/[2.5%]',
			])),
      onChange: onChange,
      onFocusin: _cache[0] || (_cache[0] = ($event: any) => (focused.value = true)),
      onFocusout: _cache[1] || (_cache[1] = ($event: any) => (focused.value = false)),
      onMouseover: _cache[2] || (_cache[2] = ($event: any) => (hovered.value = true)),
      onMouseout: _cache[3] || (_cache[3] = ($event: any) => (hovered.value = false))
    }, [
      _renderSlot(_ctx.$slots, "default")
    ], 42, _hoisted_1),
    _hoisted_2
  ], 2))
}
}

})